/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  ACHPaymentDetails,
  ACHPaymentDetails$inboundSchema,
  ACHPaymentDetails$Outbound,
  ACHPaymentDetails$outboundSchema,
} from "./achpaymentdetails.js";
import {
  CardPaymentDetails,
  CardPaymentDetails$inboundSchema,
  CardPaymentDetails$Outbound,
  CardPaymentDetails$outboundSchema,
} from "./cardpaymentdetails.js";
import {
  CollectionPaymentMethodType,
  CollectionPaymentMethodType$inboundSchema,
  CollectionPaymentMethodType$outboundSchema,
} from "./collectionpaymentmethodtype.js";

/**
 * Options for payment links used to collect payment.
 */
export type PaymentLinkPaymentDetails = {
  /**
   * A list of payment methods that should be supported for this payment link.
   */
  allowedMethods: Array<CollectionPaymentMethodType>;
  /**
   * Options for payment links used to collect a card payment.
   */
  cardDetails?: CardPaymentDetails | undefined;
  /**
   * Options for payment links used to collect an ACH payment.
   */
  achDetails?: ACHPaymentDetails | undefined;
  /**
   * Optional free-form metadata for the transfer.
   */
  metadata?: { [k: string]: string } | undefined;
};

/** @internal */
export const PaymentLinkPaymentDetails$inboundSchema: z.ZodType<
  PaymentLinkPaymentDetails,
  z.ZodTypeDef,
  unknown
> = z.object({
  allowedMethods: z.array(CollectionPaymentMethodType$inboundSchema),
  cardDetails: CardPaymentDetails$inboundSchema.optional(),
  achDetails: ACHPaymentDetails$inboundSchema.optional(),
  metadata: z.record(z.string()).optional(),
});
/** @internal */
export type PaymentLinkPaymentDetails$Outbound = {
  allowedMethods: Array<string>;
  cardDetails?: CardPaymentDetails$Outbound | undefined;
  achDetails?: ACHPaymentDetails$Outbound | undefined;
  metadata?: { [k: string]: string } | undefined;
};

/** @internal */
export const PaymentLinkPaymentDetails$outboundSchema: z.ZodType<
  PaymentLinkPaymentDetails$Outbound,
  z.ZodTypeDef,
  PaymentLinkPaymentDetails
> = z.object({
  allowedMethods: z.array(CollectionPaymentMethodType$outboundSchema),
  cardDetails: CardPaymentDetails$outboundSchema.optional(),
  achDetails: ACHPaymentDetails$outboundSchema.optional(),
  metadata: z.record(z.string()).optional(),
});

export function paymentLinkPaymentDetailsToJSON(
  paymentLinkPaymentDetails: PaymentLinkPaymentDetails,
): string {
  return JSON.stringify(
    PaymentLinkPaymentDetails$outboundSchema.parse(paymentLinkPaymentDetails),
  );
}
export function paymentLinkPaymentDetailsFromJSON(
  jsonString: string,
): SafeParseResult<PaymentLinkPaymentDetails, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => PaymentLinkPaymentDetails$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'PaymentLinkPaymentDetails' from JSON`,
  );
}
